import coreReducer, {
  WHITE_LIST as CORE_WHITE_LIST,
  BLACK_LIST as CORE_BLACK_LIST,
  FILTERS_PERSISTOR as CORE_FILTERS_PERSISTOR
} from 'src/core/store/ducks/reducers'

import general, { FILTER_PERSISTOR as FILTER_GENERAL } from './general'
import integrations from './integrations'
import myTeam from './my-team'
import receipts from './receipts'
import reports from './reports'

export default {
  ...coreReducer,
  general,
  integrations,
  myTeam,
  receipts,
  reports
}

export const WHITE_LIST: string[] = [...CORE_WHITE_LIST, 'general']

export const BLACK_LIST: string[] = [...CORE_BLACK_LIST]

export const FILTERS_PERSISTOR = [...CORE_FILTERS_PERSISTOR, FILTER_GENERAL]
